import { render, staticRenderFns } from "./heroSection.vue?vue&type=template&id=335f851a"
import script from "./heroSection.vue?vue&type=script&lang=js"
export * from "./heroSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports